import React, {Component} from 'react';
import Header from '../../components/Header/Header';
import axios from "../../axios-signup";
import Error from "../../components/UI/Error";
import {Loader} from 'react-overlay-loader';

class SignupDone extends Component {
    state = {
        emailAddress: this.props.location.state.emailAddress,
        errorMsg: '',
        loading: false
    };

    onSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        axios
            .post("/cloud-formation", {
                emailAddress: this.state.emailAddress
            })
            .then((response) => {
                this.setState({loading: false})
            })
            .catch(
                error => {
                    this.setState({errorMsg: error.response.data.error, loading: false})
                });
    };

    render() {
        return (
            <div>
                <Header currentWizard='2' done={true}/>
                <main role="main">
                    <Loader fullPage={true} loading={this.state.loading}/>
                    <section className="section yellow">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 col-center text-center">
                                    <h1 className="black"><strong>Signup Completed</strong></h1>
                                    <Error errorMsg={this.state.errorMsg} divClass="col-md-9 col-center"/>
                                    <h5 className="gray mb-4"><strong>You have completed the signup process, please check your email for instructions on how to install the CloudFormation stack.</strong></h5>
                                    <p>If you have not received the email, please contact
                                        <a href="mailto:support@xosphere.io"> support@xosphere.io</a>.</p>
                                    <input type="submit" value="Re-send Email" className="btn btn-primary"
                                           onClick={this.onSubmit}/>
                                </div>

                            </div>
                        </div>
                    </section>
                </main>
            </div>
        )
    }
}

export default SignupDone;